function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLightModeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 25a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zM8.222 22.364a1 1 0 111.414 1.414L7.515 25.9A1 1 0 116.1 24.485l2.12-2.12zM22.364 22.364a1 1 0 011.414 0l2.121 2.121a1 1 0 11-1.414 1.414l-2.12-2.12a1 1 0 010-1.415z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9a7 7 0 110 14 7 7 0 010-14zm0 12a5 5 0 000-10v10z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15a1 1 0 110 2H3a1 1 0 110-2h3zM29 15a1 1 0 110 2h-3a1 1 0 110-2h3zM6.1 6.1a1 1 0 011.415 0l2.12 2.122a1 1 0 11-1.413 1.414L6.1 7.515a1 1 0 010-1.414zM24.485 6.1A1 1 0 1125.9 7.516l-2.12 2.12a1 1 0 11-1.415-1.413L24.485 6.1zM16 2a1 1 0 011 1v3a1 1 0 11-2 0V3a1 1 0 011-1z",
    fill: props.color
  }));
}

export default SvgIconLightModeFilled;